var jade = require("/Users/shishirarora/Projects/file-upload/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var jade_debug = [ new jade.DebugItem( 1, "/Users/shishirarora/Projects/file-upload/src/views/error.jade" ) ];
try {
var buf = [];
var jade_mixins = {};
var jade_interp;
;var locals_for_with = (locals || {});(function (stack) {
jade_debug.unshift(new jade.DebugItem( 0, "/Users/shishirarora/Projects/file-upload/src/views/error.jade" ));
jade_debug.unshift(new jade.DebugItem( 1, "/Users/shishirarora/Projects/file-upload/src/views/error.jade" ));
buf.push("<!DOCTYPE html>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 2, "/Users/shishirarora/Projects/file-upload/src/views/error.jade" ));
buf.push("<html lang=\"en\">");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 3, "/Users/shishirarora/Projects/file-upload/src/views/error.jade" ));
buf.push("<head>");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 4, "/Users/shishirarora/Projects/file-upload/src/views/error.jade" ));
buf.push("<meta charset=\"utf-8\">");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 5, "/Users/shishirarora/Projects/file-upload/src/views/error.jade" ));
buf.push("<title>");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 5, jade_debug[0].filename ));
buf.push("Internal Server Error");
jade_debug.shift();
jade_debug.shift();
buf.push("</title>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 6, "/Users/shishirarora/Projects/file-upload/src/views/error.jade" ));
buf.push("<meta name=\"viewport\" content=\"width=device-width, initial-scale=1\">");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 7, "/Users/shishirarora/Projects/file-upload/src/views/error.jade" ));
buf.push("<style>");
jade_debug.unshift(new jade.DebugItem( 56, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 56, jade_debug[0].filename ));
buf.push("* {");
jade_debug.shift();
buf.push("\n");
jade_debug.unshift(new jade.DebugItem( 56, jade_debug[0].filename ));
buf.push("  line-height: 1.2;");
jade_debug.shift();
buf.push("\n");
jade_debug.unshift(new jade.DebugItem( 56, jade_debug[0].filename ));
buf.push("  margin: 0;");
jade_debug.shift();
buf.push("\n");
jade_debug.unshift(new jade.DebugItem( 56, jade_debug[0].filename ));
buf.push("}");
jade_debug.shift();
buf.push("\n");
jade_debug.unshift(new jade.DebugItem( 56, jade_debug[0].filename ));
buf.push("");
jade_debug.shift();
buf.push("\n");
jade_debug.unshift(new jade.DebugItem( 56, jade_debug[0].filename ));
buf.push("html {");
jade_debug.shift();
buf.push("\n");
jade_debug.unshift(new jade.DebugItem( 56, jade_debug[0].filename ));
buf.push("  color: #888;");
jade_debug.shift();
buf.push("\n");
jade_debug.unshift(new jade.DebugItem( 56, jade_debug[0].filename ));
buf.push("  display: table;");
jade_debug.shift();
buf.push("\n");
jade_debug.unshift(new jade.DebugItem( 56, jade_debug[0].filename ));
buf.push("  font-family: sans-serif;");
jade_debug.shift();
buf.push("\n");
jade_debug.unshift(new jade.DebugItem( 56, jade_debug[0].filename ));
buf.push("  height: 100%;");
jade_debug.shift();
buf.push("\n");
jade_debug.unshift(new jade.DebugItem( 56, jade_debug[0].filename ));
buf.push("  text-align: center;");
jade_debug.shift();
buf.push("\n");
jade_debug.unshift(new jade.DebugItem( 56, jade_debug[0].filename ));
buf.push("  width: 100%;");
jade_debug.shift();
buf.push("\n");
jade_debug.unshift(new jade.DebugItem( 56, jade_debug[0].filename ));
buf.push("}");
jade_debug.shift();
buf.push("\n");
jade_debug.unshift(new jade.DebugItem( 56, jade_debug[0].filename ));
buf.push("");
jade_debug.shift();
buf.push("\n");
jade_debug.unshift(new jade.DebugItem( 56, jade_debug[0].filename ));
buf.push("body {");
jade_debug.shift();
buf.push("\n");
jade_debug.unshift(new jade.DebugItem( 56, jade_debug[0].filename ));
buf.push("  display: table-cell;");
jade_debug.shift();
buf.push("\n");
jade_debug.unshift(new jade.DebugItem( 56, jade_debug[0].filename ));
buf.push("  vertical-align: middle;");
jade_debug.shift();
buf.push("\n");
jade_debug.unshift(new jade.DebugItem( 56, jade_debug[0].filename ));
buf.push("  margin: 2em auto;");
jade_debug.shift();
buf.push("\n");
jade_debug.unshift(new jade.DebugItem( 56, jade_debug[0].filename ));
buf.push("}");
jade_debug.shift();
buf.push("\n");
jade_debug.unshift(new jade.DebugItem( 56, jade_debug[0].filename ));
buf.push("");
jade_debug.shift();
buf.push("\n");
jade_debug.unshift(new jade.DebugItem( 56, jade_debug[0].filename ));
buf.push("h1 {");
jade_debug.shift();
buf.push("\n");
jade_debug.unshift(new jade.DebugItem( 56, jade_debug[0].filename ));
buf.push("  color: #555;");
jade_debug.shift();
buf.push("\n");
jade_debug.unshift(new jade.DebugItem( 56, jade_debug[0].filename ));
buf.push("  font-size: 2em;");
jade_debug.shift();
buf.push("\n");
jade_debug.unshift(new jade.DebugItem( 56, jade_debug[0].filename ));
buf.push("  font-weight: 400;");
jade_debug.shift();
buf.push("\n");
jade_debug.unshift(new jade.DebugItem( 56, jade_debug[0].filename ));
buf.push("}");
jade_debug.shift();
buf.push("\n");
jade_debug.unshift(new jade.DebugItem( 56, jade_debug[0].filename ));
buf.push("");
jade_debug.shift();
buf.push("\n");
jade_debug.unshift(new jade.DebugItem( 56, jade_debug[0].filename ));
buf.push("p {");
jade_debug.shift();
buf.push("\n");
jade_debug.unshift(new jade.DebugItem( 56, jade_debug[0].filename ));
buf.push("  margin: 0 auto;");
jade_debug.shift();
buf.push("\n");
jade_debug.unshift(new jade.DebugItem( 56, jade_debug[0].filename ));
buf.push("  width: 280px;");
jade_debug.shift();
buf.push("\n");
jade_debug.unshift(new jade.DebugItem( 56, jade_debug[0].filename ));
buf.push("}");
jade_debug.shift();
buf.push("\n");
jade_debug.unshift(new jade.DebugItem( 56, jade_debug[0].filename ));
buf.push("");
jade_debug.shift();
buf.push("\n");
jade_debug.unshift(new jade.DebugItem( 56, jade_debug[0].filename ));
buf.push("pre {");
jade_debug.shift();
buf.push("\n");
jade_debug.unshift(new jade.DebugItem( 56, jade_debug[0].filename ));
buf.push("  text-align: left;");
jade_debug.shift();
buf.push("\n");
jade_debug.unshift(new jade.DebugItem( 56, jade_debug[0].filename ));
buf.push("  margin-top: 2rem;");
jade_debug.shift();
buf.push("\n");
jade_debug.unshift(new jade.DebugItem( 56, jade_debug[0].filename ));
buf.push("}");
jade_debug.shift();
buf.push("\n");
jade_debug.unshift(new jade.DebugItem( 56, jade_debug[0].filename ));
buf.push("");
jade_debug.shift();
buf.push("\n");
jade_debug.unshift(new jade.DebugItem( 56, jade_debug[0].filename ));
buf.push("@media only screen and (max-width: 280px) {");
jade_debug.shift();
buf.push("\n");
jade_debug.unshift(new jade.DebugItem( 56, jade_debug[0].filename ));
buf.push("");
jade_debug.shift();
buf.push("\n");
jade_debug.unshift(new jade.DebugItem( 56, jade_debug[0].filename ));
buf.push("  body, p {");
jade_debug.shift();
buf.push("\n");
jade_debug.unshift(new jade.DebugItem( 56, jade_debug[0].filename ));
buf.push("    width: 95%;");
jade_debug.shift();
buf.push("\n");
jade_debug.unshift(new jade.DebugItem( 56, jade_debug[0].filename ));
buf.push("  }");
jade_debug.shift();
buf.push("\n");
jade_debug.unshift(new jade.DebugItem( 56, jade_debug[0].filename ));
buf.push("");
jade_debug.shift();
buf.push("\n");
jade_debug.unshift(new jade.DebugItem( 56, jade_debug[0].filename ));
buf.push("  h1 {");
jade_debug.shift();
buf.push("\n");
jade_debug.unshift(new jade.DebugItem( 56, jade_debug[0].filename ));
buf.push("    font-size: 1.5em;");
jade_debug.shift();
buf.push("\n");
jade_debug.unshift(new jade.DebugItem( 56, jade_debug[0].filename ));
buf.push("    margin: 0 0 0.3em;");
jade_debug.shift();
buf.push("\n");
jade_debug.unshift(new jade.DebugItem( 56, jade_debug[0].filename ));
buf.push("  }");
jade_debug.shift();
buf.push("\n");
jade_debug.unshift(new jade.DebugItem( 56, jade_debug[0].filename ));
buf.push("");
jade_debug.shift();
buf.push("\n");
jade_debug.unshift(new jade.DebugItem( 56, jade_debug[0].filename ));
buf.push("}");
jade_debug.shift();
buf.push("\n");
jade_debug.unshift(new jade.DebugItem( 56, jade_debug[0].filename ));
buf.push("");
jade_debug.shift();
jade_debug.shift();
buf.push("</style>");
jade_debug.shift();
jade_debug.shift();
buf.push("</head>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 57, "/Users/shishirarora/Projects/file-upload/src/views/error.jade" ));
buf.push("<body>");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 58, "/Users/shishirarora/Projects/file-upload/src/views/error.jade" ));
buf.push("<h1>");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 58, jade_debug[0].filename ));
buf.push("Internal Server Error");
jade_debug.shift();
jade_debug.shift();
buf.push("</h1>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 59, "/Users/shishirarora/Projects/file-upload/src/views/error.jade" ));
buf.push("<p>");
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.unshift(new jade.DebugItem( 59, jade_debug[0].filename ));
buf.push("Sorry, something went wrong.");
jade_debug.shift();
jade_debug.shift();
buf.push("</p>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 60, "/Users/shishirarora/Projects/file-upload/src/views/error.jade" ));
buf.push("<pre>" + (jade.escape(null == (jade_interp = stack) ? "" : jade_interp)));
jade_debug.unshift(new jade.DebugItem( undefined, jade_debug[0].filename ));
jade_debug.shift();
buf.push("</pre>");
jade_debug.shift();
jade_debug.shift();
buf.push("</body>");
jade_debug.shift();
jade_debug.shift();
buf.push("</html>");
jade_debug.shift();
jade_debug.unshift(new jade.DebugItem( 61, "/Users/shishirarora/Projects/file-upload/src/views/error.jade" ));
buf.push("<!-- IE needs 512+ bytes: http://blogs.msdn.com/b/ieinternals/archive/2010/08/19/http-error-pages-in-internet-explorer.aspx-->");
jade_debug.shift();
jade_debug.shift();}.call(this,"stack" in locals_for_with?locals_for_with.stack:typeof stack!=="undefined"?stack:undefined));;return buf.join("");
} catch (err) {
  jade.rethrow(err, jade_debug[0].filename, jade_debug[0].lineno, "doctype html\nhtml(lang=\"en\")\n  head\n    meta(charset=\"utf-8\")\n    title Internal Server Error\n    meta(name=\"viewport\", content=\"width=device-width, initial-scale=1\")\n    style.\n      * {\n        line-height: 1.2;\n        margin: 0;\n      }\n\n      html {\n        color: #888;\n        display: table;\n        font-family: sans-serif;\n        height: 100%;\n        text-align: center;\n        width: 100%;\n      }\n\n      body {\n        display: table-cell;\n        vertical-align: middle;\n        margin: 2em auto;\n      }\n\n      h1 {\n        color: #555;\n        font-size: 2em;\n        font-weight: 400;\n      }\n\n      p {\n        margin: 0 auto;\n        width: 280px;\n      }\n\n      pre {\n        text-align: left;\n        margin-top: 2rem;\n      }\n\n      @media only screen and (max-width: 280px) {\n\n        body, p {\n          width: 95%;\n        }\n\n        h1 {\n          font-size: 1.5em;\n          margin: 0 0 0.3em;\n        }\n\n      }\n\n  body\n    h1 Internal Server Error\n    p Sorry, something went wrong.\n    pre= stack\n// IE needs 512+ bytes: http://blogs.msdn.com/b/ieinternals/archive/2010/08/19/http-error-pages-in-internet-explorer.aspx\n");
}
}


//////////////////
// WEBPACK FOOTER
// ./views/error.jade
// module id = 74
// module chunks = 0